import React from 'react';
import PropTypes from 'prop-types';
import YellowTag from '@/components_cards/tags/_base/YellowTag';
import { isExpired } from '@/utils/dateTimeUtils';

export default function ExpiredTag(props) {
  const { resource } = props;

  if (
    resource.data.completed ||
    resource.data.cancelled ||
    !isExpired(resource.data.endDate)
  ) {
    return null;
  }

  return (
    <YellowTag label="TIMEFRAME ENDED" />
  );
}

ExpiredTag.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
